import React, {useState} from 'react';

import ChipSelectInput from 'ui-library/inputs/ChipSelectInput';
import {OptionValue} from 'ui-library/menus/MenuConstants';
import {getMatchingOptionDatas} from 'ui-library/menus/MenuUtil';

import LabelWrapper from '../shared/LabelWrapper';
import * as uiBlock from '../UiBlockTypes';

interface SelectorInputMultiValueUiBlockProps extends uiBlock.SelectorInputMultiValue {
  onChangeValue: (blockId: string, val: Array<string>) => void;
}

function SelectorInputMultiValueUiBlock({
  blockValue,
  options,
  onChangeValue,
  id,
  enabled,
  canvasEnabled,
  label,
  required,
  placeholder,
}: SelectorInputMultiValueUiBlockProps): JSX.Element {
  const [query, setQuery] = useState('');

  const selectedValues = blockValue?.values || [];
  const canEdit = canvasEnabled && enabled;

  const handleRemove = (value: OptionValue): void => {
    onChangeValue(
      id,
      selectedValues.filter((v) => v !== value)
    );
  };

  const handleSelect = (value: OptionValue): void => {
    if (selectedValues.includes(value)) {
      handleRemove(value);
    } else {
      onChangeValue(id, [...selectedValues, value]);
    }
  };

  return (
    <div>
      <LabelWrapper label={label} required={required} />
      <ChipSelectInput
        autoFocus={false}
        scrollable={true}
        optionDatas={getMatchingOptionDatas(
          query,
          options.map((o) => ({name: o, value: o}))
        )}
        placeholder={placeholder || 'Select...'}
        value={selectedValues}
        query={query}
        onQueryChange={(q) => {
          setQuery(q.target.value);
        }}
        isMulti={true}
        disabled={!canEdit}
        onSelect={handleSelect}
        onRemove={handleRemove}
      />
    </div>
  );
}

export default SelectorInputMultiValueUiBlock;
